var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2032C12.9051 20.2041 12.7986 20.2041 12.677 20.2041H7.19691C6.07899 20.2041 5.5192 20.2041 5.0918 19.9863C4.71547 19.7946 4.40973 19.4883 4.21799 19.112C4 18.6842 4 18.1244 4 17.0043V7.4043C4 6.28419 4 5.72372 4.21799 5.2959C4.40973 4.91957 4.71547 4.61384 5.0918 4.42209C5.51962 4.2041 6.08009 4.2041 7.2002 4.2041H16.8002C17.9203 4.2041 18.4796 4.2041 18.9074 4.42209C19.2837 4.61384 19.5905 4.91957 19.7822 5.2959C20 5.7233 20 6.2831 20 7.40101V12.8788C20 13.0014 20 13.1086 19.9991 13.2041M13 20.2032C13.2857 20.2007 13.4663 20.1903 13.6388 20.1489C13.8429 20.0999 14.0379 20.0188 14.2168 19.9091C14.4186 19.7855 14.5916 19.613 14.9375 19.2671L19.063 15.1416C19.4089 14.7957 19.5809 14.6227 19.7046 14.4209C19.8142 14.242 19.8953 14.0465 19.9443 13.8425C19.9857 13.67 19.9964 13.4896 19.9991 13.2041M13 20.2032V14.8042C13 14.2441 13 13.9639 13.109 13.75C13.2049 13.5618 13.3577 13.409 13.5459 13.3131C13.7598 13.2041 14.0396 13.2041 14.5996 13.2041H19.9991",
    stroke: "#636980",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/Policies.ac8860d5ab1035e79ef5e654a01559fe.svg";
export { ForwardRef as ReactComponent };